
import { Mixins, Component, Prop, VModel, Watch } from 'vue-property-decorator'
import { observationIcons } from '@/types/observation'
import { getPreview } from '@/utils/attachment'

@Component({
    name: 'LocationDrawingComponent',
})
export default class LocationDrawingComponent extends Mixins() {
    @VModel() observation!: any
    @Prop({ default: true }) disabled!: any
    @Prop({ default: false }) isLog!: any

    getPreview = getPreview
    observationIcons = observationIcons
    loadingImage = true
    errorImage = false
    cacheBuster = Date.now() // To force image reload on change
    imageWidth = 768 // Default image width
    devicePixelRatio = 1 // Default device pixel ratio

    get getImageUrl() {
        // Calculate the required image width considering device scaling
        const scaledWidth = Math.round(this.imageWidth * this.devicePixelRatio)

        return (
            this.getPreview(this.observation.locationDrawing.data.fileId) +
            `?maxImgWidth=${scaledWidth}&maxWaitSeconds=20&timestamp=${this.cacheBuster}`
        )
    }

    onImageLoad() {
        this.updateImageSize()
        this.loadingImage = false
        this.errorImage = false
    }

    onImageError() {
        this.loadingImage = false
        this.errorImage = true
    }

    updateDevicePixelRatio() {
        // Get current device pixel ratio (accounts for user scaling)
        this.devicePixelRatio = window.devicePixelRatio || 1
    }

    updateImageSize() {
        this.$nextTick(() => {
            const img = this.$refs.locationDrawing as HTMLImageElement
            const wrap = this.$refs.locationDrawingWrap as HTMLElement
            const container = this.$el as HTMLElement

            if (img && container) {
                // Get the actual available container width
                const containerWidth = container.clientWidth

                // Update our imageWidth property based on the actual container size
                this.imageWidth = containerWidth

                // Adjust the wrap size based on the image's natural size and container limits
                const containerHeight = container.clientHeight
                const aspectRatio = img.naturalWidth / img.naturalHeight

                let width = containerWidth
                let height = width / aspectRatio

                if (height > containerHeight) {
                    height = containerHeight
                    width = height * aspectRatio
                }

                // Set the wrap and image dimensions
                wrap.style.width = `${width}px`
                wrap.style.height = `${height}px`
                img.style.width = `${width}px`
                img.style.height = `${height}px`
            }
        })
    }

    setDotPosition(event) {
        if (this.disabled || this.errorImage) return
        const img = this.$refs.locationDrawing as HTMLElement

        const rect = img.getBoundingClientRect()

        this.observation.locationDrawingX = (event.clientX - rect.left) / rect.width
        this.observation.locationDrawingY = (event.clientY - rect.top) / rect.height

        this.observation.locationDrawingX = Math.max(
            0,
            Math.min(1, this.observation.locationDrawingX)
        )
        this.observation.locationDrawingY = Math.max(
            0,
            Math.min(1, this.observation.locationDrawingY)
        )
    }

    @Watch('observation.locationDrawing.data', { deep: true })
    onImageDataChange() {
        this.loadingImage = true
        this.cacheBuster = Date.now() // Force image reload if image failed before
        this.errorImage = false
    }

    mounted() {
        this.updateDevicePixelRatio()
        this.updateImageSize()
        window.addEventListener('resize', this.handleResize)
    }

    handleResize() {
        this.updateDevicePixelRatio()
        this.updateImageSize()
        // Force reload of the image with the new dimensions
        this.cacheBuster = Date.now()
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    }
}
